import * as React from 'react';
import { connect } from "react-redux";
import { Button, Tabs, Breadcrumb, Col, Row } from 'antd';
import { Route } from "antd/lib/breadcrumb/Breadcrumb";
import autobind from 'autobind-decorator';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { Prompt } from 'react-router';
import { Dispatch } from 'redux';

import { HeaderView } from 'src/app/shared/header.view';
import { AllotmentGeneralPartView } from './parts/allotment-general.view';
import { AllotmentAllotmentRangeController } from './parts/allotment-allotmentrange.controller';
import { AllotmentAvailabilityController } from './parts/allotment-availability.controller';
import { AllotmentRangeFormView } from 'src/app/products/allotment-range/form/allotment-range-form.view';
import { ToastNotifications } from 'src/core/ui/toast';
import { ZuluIcon } from 'src/app/shared/icon';
import { actionCreators } from "src/store/products/product-form-nav-actions";

interface PropsFromState {
	breadcrumb: ReadonlyArray<Readonly<BreadcrumbItem<ProductFormItemType>>>;
}

interface PropsFromDispatch {
	navigateDown: (entity: any) => any;
}

type ContainerProps = PropsFromState & PropsFromDispatch;

const TabPane = Tabs.TabPane;

interface Props extends ComponentViewProps<AllotmentItem> {
	title?: string,
	save?: () => void,
	cancel?: () => void,
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	contextService?: any;
	formatService: any;
	toast: ToastNotifications;
	defaultLanguaje: string;
	fromContract?: boolean
	fullscreen?: boolean;
	avalabilities?: AvailabilityAllotments;
	productTypeText?: string,
	categoryDisplayName?: string,
	productDisplayName?:string
}

@observer
class AllotmentFormView extends React.Component<Props & ContainerProps, any> {

	render() {
		const { breadcrumb } = this.props;

		if (this.props.model == null) {
			return null;
		}

		let latest: BreadcrumbItem<ProductFormItemType> = null;
		let previous: BreadcrumbItem<ProductFormItemType> = null;
		let breadcrumUI = null;
		if (this.props.save) {
			latest = breadcrumb == null || breadcrumb.length == 1
				? null
				: breadcrumb[breadcrumb.length - 1];
			previous = breadcrumb == null
				? null
				: breadcrumb[breadcrumb.length - 2];
			breadcrumUI = breadcrumb == null || breadcrumb.length == 0
				? null
				: (
					<div className='card header'>
						<Breadcrumb
							className="m-1"
							separator={<ZuluIcon type='right' />}
							itemRender={this.renderBreadcrumbItem}
							routes={breadcrumb.map(e => ({
								path: e.entity.id.toString(),
								breadcrumbName: e.key,
							}))}
						/>
					</div>
				);
		}

		return (
			<div className="window window-normal">
				{!this.props.fromContract && this.renderPrompt()}
				{
					this.props.save && <Row>
						<Col xs={24} xl={this.props.fullscreen ? 24 : { offset: 3, span: 18 }}>
							<HeaderView
								title={this.props.title}
								mode={this.props.mode}
								onModeChanged={this.props.onModeChanged}
								save={this.props.save}
								cancel={this.props.cancel}
								contextService={this.props.contextService}
							/>
						</Col>
						<Col xs={24} xl={this.props.fullscreen ? 24 : { offset: 3, span: 18 }}>
							{breadcrumUI}
						</Col>
					</Row>
				}
				{
					this.props.model && latest == null &&
					<Row>
						<Col xs={24} xl={this.props.fullscreen ? 24 : { offset: 3, span: 18 }}>
							<div className='card p-3'>
								<Tabs >
									<TabPane tab='General information' key="General information">
										<AllotmentGeneralPartView
											mode={this.props.mode}
											defaultLanguaje={this.props.defaultLanguaje}
											onModeChanged={this.props.onModeChanged}
											model={latest == null ? this.props.model : null}
											setBusy={this.props.setBusy}
											fromContract={this.props.fromContract}
											productTypeText={this.props.productTypeText}
											categoryDisplayName={this.props.categoryDisplayName}
											productDisplayName={this.props.productDisplayName}
										/>
									</TabPane>
									<TabPane tab='Allotment ranges' key="Allotment ranges">
										<AllotmentAllotmentRangeController
											contextService={this.props.contextService}
											formatService={this.props.formatService}
											mode={this.props.mode}
											onModeChanged={this.props.onModeChanged}
											model={this.props.model}
											setBusy={this.props.setBusy}
											toast={this.props.toast}
											defaultLanguage={this.props.defaultLanguaje}
										/>
									</TabPane>
									{this.props.model.supplierId && <TabPane tab='Allotment availability' key="Allotment availability">
										<AllotmentAvailabilityController
											defaultLanguaje={this.props.defaultLanguaje}
											suppliers={[]}
											idSuplier={this.props.model.supplierId}
											contextService={this.props.contextService}
											mode={this.props.mode}
											onModeChanged={this.props.onModeChanged}
											model={this.props.model.id}
											setBusy={this.props.setBusy}
											allotment={this.props.model}
										/>
									</TabPane>}
								</Tabs>
							</div>
						</Col>
					</Row>
				}
				{
					latest != null && latest.key == 'allotmentRange' &&
					<Col xs={24} xl={this.props.fullscreen ? 24 : { offset: 3, span: 18 }}>
						<div className="card p-3">
							<AllotmentRangeFormView
								contextService={this.props.contextService}
								formatService={this.props.formatService}
								mode={this.props.mode}
								allotment={previous.entity as AllotmentItem}
								onModeChanged={this.props.onModeChanged}
								setBusy={this.props.setBusy}
								model={latest.entity as AllotmentRangeItem}
							/>
						</div>
					</Col>
				}
			</div>
		);
	}

	private renderPrompt(): React.ReactNode {
		return (
			<Prompt
				when={this.props.contextService.isDirty}
				message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
			/>
		);
	}

	private renderBreadcrumbItem = (route: Route): React.ReactNode => {
		const { breadcrumb, navigateDown } = this.props;
		const item = breadcrumb.find(e => e.key === route.breadcrumbName && e.entity.id.toString() === route.path);
		return (
			<Button
				style={{ height: '100%' }}
				onClick={() => navigateDown(item)}
			>
				<span key="0">{item.title}</span>
				<ZuluIcon key="1" type="close" />
				<br key="2" />
				<span key="3">{item.text}</span>
			</Button>
		);
	}
}

const mapStateToProps = (state: IApplicationState): PropsFromState => {
	return {
		breadcrumb: state.productFormBreadcrumb,
	};
};

const mapDispatchToProps = (dispatch: Dispatch): PropsFromDispatch => {
	return {
		navigateDown: (entity) => dispatch(actionCreators.productFormDownNav(entity)),
	};
}

const connected = connect(
	mapStateToProps,
	mapDispatchToProps,
)(AllotmentFormView);
export { connected as AllotmentFormView };



// WEBPACK FOOTER //
// ./src/app/products/allotment/form/allotment-form.view.tsx